import { connect } from 'react-redux';
import Stakeholders from './Stakeholders';
import { project} from "../../../store/selectors/projects.selector";

const mapDispatchToProps = {  };

const mapStateToProps = (state) => { 
    const projectDetails = project(state);
    return { projectDetails};
 };

export default connect(mapStateToProps, mapDispatchToProps)(Stakeholders);